import { Col, Form, Input, Modal, Row, notification } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Patientportal_PortalUserMsg, useUpdatePortalUserMutation } from '@/generated/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import { buildPortalUserUpdateInput } from '../../helpers/portal-user';
import { AveliosButton } from '../common-layout/avelios-button';

interface ChangeNameModalProps {
  currentUser: Maybe<Patientportal_PortalUserMsg> | undefined;
  currentUserLoading: boolean;
  open: boolean;
  onClose: () => void;
}

export const ChangeNameModal: FC<ChangeNameModalProps> = ({
  currentUser,
  currentUserLoading = false,
  open,
  onClose,
}) => {
  const { formatMessage } = useIntl();

  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');

  useEffect(() => {
    setFirstName(currentUser?.name?.firstName ?? '');
    setLastName(currentUser?.name?.lastName ?? '');
  }, [currentUser?.name?.firstName, currentUser?.name?.lastName]);

  const [updatePortalUser, { loading: updateLoading }] = useUpdatePortalUserMutation({
    onCompleted: () => {
      notification.success({
        message: formatMessage({ id: 'change-name.success' }),
      });
      onClose();
    },
    onError: () => {
      notification.error({
        message: formatMessage({ id: 'change-name.error' }),
      });
    },
  });

  const loading = currentUserLoading || updateLoading;

  const handleSave = () => {
    const baseInput = buildPortalUserUpdateInput(currentUser);
    updatePortalUser({
      variables: {
        input: {
          ...baseInput,
          name: { ...baseInput.name, firstName, lastName },
        },
      },
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={
        <AveliosButton
          loading={loading}
          type="primary"
          onClick={handleSave}
          disabled={!firstName || !lastName}
        >
          {formatMessage({ id: 'action.save' })}
        </AveliosButton>
      }
      closable={true}
      title={<h2>{formatMessage({ id: 'change-name' })}</h2>}
    >
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              required
              label={formatMessage({ id: 'change-name.first-name' })}
            >
              <Input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={formatMessage({ id: 'change-name.first-name' })}
                disabled={loading}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              required
              label={formatMessage({ id: 'change-name.last-name' })}
            >
              <Input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={formatMessage({ id: 'change-name.last-name' })}
                disabled={loading}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
